import AsideContent from "../asideContent/AsideContent.component";
import ListIcon from "../listIcon/ListIcon.component";
import "./styles.scss";
import { useTranslation } from "react-i18next";
import LanguageButton from "components/common/lanButton/LanguageButton.component";
export default function Principal() {
  const { t } = useTranslation();

  return (
    <article className="content-wrapper">
      <AsideContent />
      <div className="main-content middle-column">
        <LanguageButton />

        <article className="main-content__child">
          <h1 className="title">{t("home.title")}</h1>
          <h2 className="subtitle">{t("home.subtitle")}</h2>
          <section className="content-text">
            <p>{t("home.content.first")}</p>
            <p>{t("home.content.second")}</p>
            <p>{t("home.content.third")}</p>
            <p>{t("home.content.fourth")}</p>
            <p>
              {t("home.content.fifth")}{" "}
              <a
                href="https://controldecambios.com/"
                className="external_links"
              >
                Control de cambios
              </a>
              |
              <a
                href="https://open.spotify.com/show/66phcUoQsM3URyzhFDz9ig?si=Xhy4XLfUSmeAKjBs-44c4w"
                className="external_links"
              >
                Platzi Podcast
              </a>
              |
              <a
                href="http://wecodesignpodcast.com/"
                className="external_links"
              >
                We code SignIn
              </a>
            </p>
            <p>
              {t("home.content.six.first")}
              <a
                href="mailto:faherrera.dev@gmail.com"
                className="external_links"
              >
                faherrera.dev@gmail.com
              </a>
              , {t("home.content.six.second")}{" "}
              <a
                href="/download/MyCV.pdf"
                target="_blank"
                className="external_links"
              >
                my resume here
              </a>
              {t("home.content.six.third")}
            </p>
          </section>
          <ListIcon />
        </article>
      </div>
    </article>
  );
}
